/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invoice_Request_ExplainerInputs */

const en_invoice_request_explainer = /** @type {(inputs: Invoice_Request_ExplainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your invoice is usually ready right away; if your trainer still has to issue it, you'll find it here once they do. Until then, this payment's confirmation is your proof of paying.`)
};

const pl_invoice_request_explainer = /** @type {(inputs: Invoice_Request_ExplainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faktura zwykle jest gotowa od razu. Jeśli trener musi ją jeszcze wystawić, znajdziesz ją tutaj, gdy to zrobi. Do tego czasu dowodem zapłaty jest potwierdzenie płatności.`)
};

/**
* | output |
* | --- |
* | "Your invoice is usually ready right away; if your trainer still has to issue it, you'll find it here once they do. Until then, this payment's confirmation is..." |
*
* @param {Invoice_Request_ExplainerInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const invoice_request_explainer = /** @type {((inputs?: Invoice_Request_ExplainerInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invoice_Request_ExplainerInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_invoice_request_explainer(inputs)
	return en_invoice_request_explainer(inputs)
});